<template>
  <div class="goods-card-container">
    <div class="card-image">
      <GoodsCardImage />
    </div>
    <div class="card-desc">
      <GoodsCardDesc />
    </div>
  </div>
</template>

<script>
import GoodsCardImage from '@/components/base/card/image'
import GoodsCardDesc from '@/components/base/card/desc'

export default {
  name: 'GoodsCard',

  components: {
    'GoodsCardImage': GoodsCardImage,
    'GoodsCardDesc': GoodsCardDesc
  },

  props: {
    type: {
      value: '',
      default () {
        return 'horizontal'
      }
    },

    customClassName: {
      value: ''
    }
  }
}
</script>

<style lang="scss">
.goods-card-container {
  direction: flex;
  width: 400px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 10px;
  .card-image {
    box-sizing: border-box;
    border: 1px solid #ccc;
    width: 100px;
    height: 100px;
    .image-container {
      width: 100%;
      height: 100%;
      .image_ad {
        width: 100%;
      }
    }
  }
}
</style>